/*
PROPS:
  size = ["default", "lg", "sm"]
  type = ["button", "submit"]
  color = ["blue", "yellow", "white", "green", "red"]
  icon = cualquier icono valido en fontawesome
  animation =["fade-in"]
*/

const CustomButton = ({
  additionalClasses = "",
  type = "button",
  text = "",
  size = "default",
  color = "blue",
  onClick = () => {},
  icon,
  animation = "none",
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={`btn btn-custom ${size !== "default" ? `btn-${size}` : ""} btn-${color} ${
        animation !== "none" && `animated--${animation}`
      } ${additionalClasses}`}
    >
      {icon && <i className={`fas fa-${icon} mr-2`} />}
      {text}
    </button>
  );
};

export default CustomButton;
